<template>
  <div>
    <Head title="Verifikasi Laporan Pertanggung Jawaban" />
    <h1 class="mb-8 text-2xl font-bold">Verifikasi Laporan Pertanggung Jawaban</h1>
    <div class="w-full mb-8 bg-white rounded-md shadow">
      <div class="w-full p-4 bg-gray-200">Filter</div>
      <div class="flex flex-wrap w-full p-6">
        <div class="w-full lg:w-3/12">Periode Pertanggung Jawaban:</div>
        <v-select
          v-model="form.periode" :options="periodes" class="w-full lg:w-9/12" :reduce="periode => periode.id"
          label="nama" placeholder="Pilih Periode"
        />
        <div class="w-full mt-2 lg:w-3/12">Jenis Perguruan Tinggi:</div>
        <v-select
          v-model="form.status_university" :options="universityTypes" class="w-full mt-2 lg:w-9/12" :reduce="type => type.id"
          label="nama" placeholder="Pilih Jenis Perguruan Tinggi"
        />
        <div class="w-full mt-2 lg:w-3/12">Universitas:</div>
        <v-select
          v-model="form.university" :options="universities" class="w-full mt-2 lg:w-9/12"
          :reduce="university => university.id" label="nama" placeholder="Pilih Universitas"
        />
        <div class="w-full mt-2 lg:w-3/12">Prodi:</div>
        <v-select
          v-model="form.prodi" :options="prodis" class="w-full mt-2 lg:w-9/12" :reduce="prodi => prodi.id"
          label="nama" placeholder="Pilih Prodi"
        />
        <div class="w-full mt-2 lg:w-3/12">Nama/ NIM Mahasiswa:</div>
        <text-input v-model="form.search" class="w-full mt-2 lg:w-9/12" placeholder="Search..." autofocus />
      </div>
    </div>
    <div class="overflow-x-auto bg-white rounded-md shadow">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="font-bold text-left">
            <th class="px-6 pt-6 pb-4">Data Beasiswa</th>
            <th class="px-6 pt-6 pb-4">Data Mahasiswa</th>
            <th class="px-6 pt-6 pb-4" colspan="2">Laporan</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="application in applications.data" :key="application.id"
            class="hover:bg-gray-100 focus-within:bg-gray-100"
          >
            <td class="p-4 border-t">
              <Link :href="`/verify-final-reports/${application.id}`" tabindex="-1">
                {{ application.periode }}
                <p class="mt-2">Tgl. Pelaporan : {{ application.tgl_pelaporan }}</p>
              </Link>
              <ul class="mt-2">
                <li class="leading-6">Jenis Beasiswa:  {{ application.jenis_pt }} - {{ application.jenis }}</li>
                <li class="leading-6">
                  Nominal Anggaran : Rp. {{ $filters.formatNumber(application.nominal_beasiswa, 0) }}
                </li>
              </ul>
            </td>
            <td class="p-4 border-t">
              <Link :href="`/verify-final-reports/${application.id}`" tabindex="-1">
                <ul>
                  <li class="leading-6">Nama : {{ application.nama }}</li>
                  <li class="leading-6">NIM : {{ application.nim }}</li>
                  <li class="leading-6">Universitas : {{ application.nama_universitas }}</li>
                  <li class="leading-6">Prodi : {{ application.nama_prodi }}</li>
                </ul>
              </Link>
            </td>
            <td class="p-4 border-t">
              <Link :href="`/verify-final-reports/${application.id}`" tabindex="-1">
                <ul>
                  <li class="leading-6">Biaya Pendidikan : Rp. {{ $filters.formatNumber(application.tuition_fee) }}</li>
                  <li class="leading-6">Biaya Lainnya : Rp. {{ $filters.formatNumber(application.other_fee) }}</li>
                  <li class="leading-6">IPK : {{ application.ipk }} </li>
                  <li class="leading-6">Semester : {{ application.semester }}</li>
                  <li class="leading-6">No. Rekening : {{ application.account_number }}</li>
                </ul>
              </Link>
            </td>
            <td class="w-px border-t">
              <Link class="flex items-center px-4" :href="`/verify-final-reports/${application.id}`" tabindex="-1">
                <font-awesome-icon icon="fas fa-chevron-right" class="block w-6 h-6 mr-2" />
              </Link>
            </td>
          </tr>
          <tr v-if="applications.data.length === 0">
            <td class="px-6 py-4 border-t" :colspan="can('write permohonan beasiswa') ? 5 : 4">
              Tidak ada data pelaporan
              beasiswa.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="applications.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'
import pickBy from 'lodash/pickBy'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import TextInput from '../../Shared/TextInput.vue'

export default {
  components: {
    Head,
    Link,
    Pagination,
    TextInput,
  },
  layout: Layout,
  props: {
    applications: Object,
    filters: Object,
    universities: Array,
    prodis: Array,
    periodes: Array,
  },

  data() {
    return {
      form: {
        university: parseInt(this.filters.university) || null,
        prodi: parseInt(this.filters.prodi) || null,
        periode: parseInt(this.filters.periode) || null,
        search: this.filters.search,
        jenis: parseInt(this.filters.jenis) || null,
        status_university: this.filters.status_university,
      },
      universityTypes: [
        { id: 'PTN', nama: 'PTN' },
        { id: 'PTNL', nama: 'PTNL' },
        { id: 'PTKL', nama: 'PTKL' },
        { id: 'PTS', nama: 'PTS' },
      ],
    }
  },

  watch: {
    form: {
      handler: throttle(function () {
        let query = pickBy(this.form)
        this.$inertia.get(this.route('verify-final-reports.index')
          , Object.keys(query).length ? query : { remember: 'forget' }
          , {
            preserveState: true,
            preserveScroll: true,
          })
      }, 150),
      deep: true,
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
